var render = function render(){
  var _vm$$route$query;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    staticClass: "p-4 bg-white rounded shadow-sm",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Category *"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "maintenance_component_id",
      "required": "",
      "placeholder": "Select Component Equipment",
      "label": "component_name",
      "options": _vm.options.category,
      "reduce": function reduce(opt) {
        return opt.id;
      },
      "disabled": (_vm$$route$query = _vm.$route.query) === null || _vm$$route$query === void 0 ? void 0 : _vm$$route$query.maintenance_component_id
    },
    model: {
      value: _vm.form.maintenance_component_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "maintenance_component_id", $$v);
      },
      expression: "form.maintenance_component_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Equipment Name *"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "placeholder": "Select Equipment name",
      "disabled": !_vm.form.maintenance_component_id,
      "label": "equipment_name",
      "options": _vm.options.equipments,
      "reduce": function reduce(opt) {
        return opt.id;
      }
    },
    model: {
      value: _vm.form.maintenance_master_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "maintenance_master_id", $$v);
      },
      expression: "form.maintenance_master_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Name *"
    }
  }, [_c('b-form-input', {
    attrs: {
      "required": "",
      "placeholder": "Enter job name"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Code *"
    }
  }, [_c('b-form-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: _vm.form.code,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "code", $$v);
      },
      expression: "form.code"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Class *"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "placeholder": "Select Job Class",
      "options": _vm.options.jobClass,
      "label": "jobClass",
      "reduce": function reduce(opt) {
        return opt.id;
      }
    },
    model: {
      value: _vm.form.maintenance_job_class_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "maintenance_job_class_id", $$v);
      },
      expression: "form.maintenance_job_class_id"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    staticClass: "mb-2",
    attrs: {
      "label": "Job Type *"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "placeholder": "Select Job Type",
      "options": _vm.options.jobType,
      "label": "description",
      "reduce": function reduce(opt) {
        return opt.id;
      }
    },
    model: {
      value: _vm.form.maintenance_job_type_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "maintenance_job_type_id", $$v);
      },
      expression: "form.maintenance_job_type_id"
    }
  })], 1), _vm.findLableJobType(_vm.form.maintenance_job_type_id) == 'general overhaul' ? _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    attrs: {
      "id": "is_reset"
    },
    model: {
      value: _vm.form.is_reset,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "is_reset", $$v);
      },
      expression: "form.is_reset"
    }
  }), _c('label', {
    staticClass: "mb-0",
    attrs: {
      "for": "is_reset"
    }
  }, [_vm._v("Reset Running Hours")])], 1) : _vm._e()], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Attachment"
    }
  }, [_c('b-form-file', {
    model: {
      value: _vm.form.file,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "file", $$v);
      },
      expression: "form.file"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Method *"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: 'Calendar Trigger',
        value: 'CALENDAR'
      }, {
        text: 'Counter Trigger',
        value: 'COUNTER'
      }]
    },
    model: {
      value: _vm.form.method,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "method", $$v);
      },
      expression: "form.method"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_vm.form.method === 'COUNTER' ? _c('b-form-group', {
    attrs: {
      "label": "Engine Type *"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "multiple": "",
      "placeholder": "Select Engine Type",
      "options": _vm.options.powerTypes,
      "label": "text",
      "reduce": function reduce(opt) {
        return opt.value;
      }
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function fn(option) {
        return [_c('div', {
          class: {
            'text-primary font-weight-bold': _vm.form.power_type_ids && _vm.form.power_type_ids.includes(option.value)
          }
        }, [_vm.form.power_type_ids && _vm.form.power_type_ids.includes(option.value) ? _c('i', {
          staticClass: "fas fa-check text-success mr-2"
        }) : _vm._e(), _vm._v(" " + _vm._s(option.text) + " ")])];
      }
    }], null, false, 4123622020),
    model: {
      value: _vm.form.power_type_ids,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "power_type_ids", $$v);
      },
      expression: "form.power_type_ids"
    }
  })], 1) : _vm._e()], 1), _vm.form.method === 'CALENDAR' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Calendar Type *"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": ['DAY', 'WEEK', 'MONTH', 'YEAR'],
      "required": ""
    },
    model: {
      value: _vm.form.calendar_type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "calendar_type", $$v);
      },
      expression: "form.calendar_type"
    }
  })], 1)], 1) : _vm._e(), _vm.form.method === 'CALENDAR' ? _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Calendar Interval *"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function fn() {
        return undefined;
      },
      proxy: true
    }], null, false, 1321973649)
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "required": ""
    },
    model: {
      value: _vm.form.calendar_interval,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "calendar_interval", $$v);
      },
      expression: "form.calendar_interval"
    }
  })], 1)], 1) : _vm._e(), _vm.form.method === 'COUNTER' ? _c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("Counter Triggers")]), _c('div', [_c('table', {
    staticClass: "table table-bordered align-middle"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "45%"
    }
  }, [_vm._v("Engine Name")]), _c('th', {
    staticStyle: {
      "width": "35%"
    }
  }, [_vm._v("Interval")]), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "10%"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus text-primary cursor-pointer",
    on: {
      "click": _vm.addCounterTrigger
    }
  })])])]), _c('tbody', _vm._l(_vm.form.counter_triggers, function (trigger, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('v-select', {
      attrs: {
        "options": _vm.filteredPowerSeriesOptions(index),
        "reduce": function reduce(val) {
          return val.value;
        },
        "label": "text",
        "required": ""
      },
      model: {
        value: trigger.power_series_id,
        callback: function callback($$v) {
          _vm.$set(trigger, "power_series_id", $$v);
        },
        expression: "trigger.power_series_id"
      }
    })], 1), _c('td', [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('InputCurrency', {
      attrs: {
        "prepend": '',
        "required": "",
        "append": "Hours"
      },
      model: {
        value: trigger.interval,
        callback: function callback($$v) {
          _vm.$set(trigger, "interval", $$v);
        },
        expression: "trigger.interval"
      }
    })], 1)]), _c('td', {
      staticClass: "text-center"
    }, [_c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.removeCounterTrigger(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)]);
  }), 0)])])]) : _vm._e(), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Job Description"
    }
  }, [_c('wysiwyg', {
    style: {
      minHeight: '200px'
    },
    attrs: {
      "placeholder": "Describe job here..."
    },
    model: {
      value: _vm.form.job_description,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "job_description", $$v);
      },
      expression: "form.job_description"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-end mt-4"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.loading
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel & Close ")]), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.loading
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-2",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.loading ? 'Submitting...' : 'Submit') + " ")], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }